import { render, staticRenderFns } from "./Nuevo.vue?vue&type=template&id=7528b0ac&"
import script from "./Nuevo.vue?vue&type=script&lang=js&"
export * from "./Nuevo.vue?vue&type=script&lang=js&"
import style0 from "./Nuevo.vue?vue&type=style&index=0&id=7528b0ac&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports